import {enqueueSnackbar} from 'notistack'
import {toast} from 'react-toastify'

export const getSnackBar = (message, variant = false) => {
  let type = variant ? 'success' : 'error'
  enqueueSnackbar(message, {
    variant: type,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}

export const getSnackBarToast = (message, type = 'success') => {
  switch (type){
    case 'success':
      toast.success(message);
      break;
    case 'error':
      toast.error(message);
      break;
    case 'warning':
      toast.warning(message);
      break;
    case 'info':
      toast.info(message);
      break;
    default:
      toast.success(message);        
  }
}